import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");

export const PRODUCTION_HOSTNAMES = ["vos-biscuits-pref.fr", "www.vos-biscuits-pref.fr"];

export const OPERATION_START_DATE = "2026-06-21T22:00:59.000Z";
export const OPERATION_END_DATE = "2026-08-02T21:59:00.000Z";
export const STATUS_PAGE_END_DATE = "2026-09-02T21:59:00.000Z";

export const OPERATION_START_LABEL = dayjs(OPERATION_START_DATE)
  .locale("fr")
  .format("DD MMMM YYYY");

export const ROUTES_ALLOWED_OUTSIDE_OPERATION = [
  "attente-jeu",
  "jeu-fini",
  "maintenance-jeu",
  "contact",
  "contact-confirmation",
  "politique-de-confidentialite",
  "mentions-legales",
];

const formatDateLabel = (isoDate) =>
  dayjs(isoDate).locale("fr").format("DD MMMM YYYY");

export const OPERATION_DATE_RANGE_LABEL = `Du ${formatDateLabel(
  OPERATION_START_DATE,
)} au ${formatDateLabel(OPERATION_END_DATE)}`;

export function isProductionDomain(hostname = window.location.hostname) {
  return PRODUCTION_HOSTNAMES.includes(hostname);
}

export function isOperationNotStarted(now = dayjs()) {
  return now.isBefore(dayjs(OPERATION_START_DATE));
}

export function isOperationEnded(now = dayjs()) {
  return now.isAfter(dayjs(OPERATION_END_DATE));
}

export function isStatusPageStillAccessible(now = dayjs()) {
  return !now.isAfter(dayjs(STATUS_PAGE_END_DATE));
}
